import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Spinner } from '../components/Spinner';
import { EmptyState } from '../components/EmptyState';
import { useAuth } from './AuthProvider';
import { canAccess, type Area } from './roles';

export function FullPageSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Spinner size="lg" />
    </div>
  );
}

/** Redirects to /login when there is no session (initial load or expiry). */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <FullPageSpinner />;
  if (!user) {
    const from = location.pathname + location.search;
    return <Navigate to="/login" replace state={{ from }} />;
  }
  return children;
}

/** Shows a "not available" message when the role can't use this area. */
export function RequireArea({ area, children }: { area: Area; children: ReactNode }) {
  const { user } = useAuth();
  if (!user || !canAccess(user.role, area)) {
    return <EmptyState title="Not available">Your role doesn't have access to this page.</EmptyState>;
  }
  return children;
}
